import React, {Component} from 'react'
import { withRouter } from 'react-router-dom'
import asyncWrapper from '../../../../../shared/javascripts/hocs/asyncWrapper'
import { Panel } from 'react-bootstrap'
import Loading from '../../../../../shared/javascripts/components/Loading'
import LoadingError from '../../../../../shared/javascripts/components/LoadingError'
import MonitoringApi from '../../api/MonitoringApi'
import ServerPanel from './ServerPanel'
import DataPanel from './DataPanel'

class TabContent extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    MonitoringApi.statuses('dataquest')
      .then(this.props.handleErrors)
      .then(response => {
        this.props.saveDataquestData(response)
      }).then(() => this.props.setLoading()).catch(error => console.log(error))
  }

  render() {
    if(this.props.loading) { return <Loading />}
    const dataquestData = this.props.dataquestData;
    if(dataquestData.error || dataquestData.data.source_error) {return <LoadingError message={dataquestData.error || dataquestData.source_error} />}
    return(
      <div className='TabContent'>
        <ServerPanel data={dataquestData.data} />
        <DataPanel data={dataquestData.data} />
      </div>
    )
  }
}

export default asyncWrapper(withRouter(TabContent))


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/Dataquest/TabContent.jsx